import { useRef, useEffect, useState } from "react";
import GlobalBankAccount from "../assets/Global-Bank-Account.webp";
import { HiBadgeCheck } from "react-icons/hi";

export default function Globalbankaccounts() {
  const imageRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.3 }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, []);

  return (
    <section className="py-16 sm:py-20 md:py-24 mt-10 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-20 max-w-7xl mx-auto">
      <h2 className="text-center text-[#1A202C] text-2xl sm:text-3xl md:text-4xl font-bold mb-8 sm:mb-12 md:mb-16">
        Global Bank Accounts
      </h2>
      
      <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
        {/* Image Container */}
        <div className="w-full lg:w-1/2 flex justify-center lg:justify-start">
          <img
            ref={imageRef}
            loading="lazy"
            src={GlobalBankAccount}
            alt="Global Bank Accounts"
            className={`w-full max-w-md lg:max-w-full object-contain transition-transform duration-700 ease-in-out ${
              inView ? "scale-100" : "scale-90"
            }`}
          />
        </div>
        
        {/* Content Container */}
        <div className="w-full lg:w-1/2 text-[#1A202C] text-center lg:text-left">
          <p className="text-lg sm:text-xl md:text-2xl font-inter mb-6 sm:mb-8">
            Open local accounts in the USA, UK, Canada & Europe — get paid faster,
            hassle-free.
          </p>
          
          <div className="flex justify-center lg:justify-start">
            <ul className="font-inter text-base sm:text-lg space-y-3 sm:space-y-4 text-left max-w-lg">
              <li className="flex items-start sm:items-center">
                <HiBadgeCheck className="text-[#26a887] mr-3 w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0 mt-0.5 sm:mt-0" />
                <span className="flex-1 text-[#6a7282]">
                  Open global accounts in your business name
                </span>
              </li>
              <li className="flex items-start sm:items-center">
                <HiBadgeCheck className="text-[#26a887] mr-3 w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0 mt-0.5 sm:mt-0" />
                <span className="flex-1 text-[#6a7282]">
                  Get your account in 1 day — no delays
                </span>
              </li>
              <li className="flex items-start sm:items-center">
                <HiBadgeCheck className="text-[#26a887] mr-3 w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0 mt-0.5 sm:mt-0" />
                <span className="flex-1 text-[#6a7282]">
                  Clients pay via local methods (ACH, SEPA, EFT)
                </span>
              </li>
              <li className="flex items-start sm:items-center">
                <HiBadgeCheck className="text-[#26a887] mr-3 w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0 mt-0.5 sm:mt-0" />
                <span className="flex-1 text-[#6a7282]">
                  Accept 30+ global currencies
                </span>
              </li>
              <li className="flex items-start sm:items-center">
                <HiBadgeCheck className="text-[#26a887] mr-3 w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0 mt-0.5 sm:mt-0" />
                <span className="flex-1 text-[#6a7282]">
                  Receive payments in India within 24 hours
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}